// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FFX-","content":"styles_content__A7F-d","tableWrap":"styles_tableWrap__1_GKk"};